import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, LinearProgress } from "@material-ui/core";
import debounce from "lodash/debounce";
import api from "../../../store/api";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import AdHocRequests from "./TransfersTables/AdHocRequests";
import { IDropResult } from "../types/plannerTypes";
import { Targets } from "../../../common/dndHelper";
import clsx from "clsx";
import { MODAL_TYPE } from "./PlannerTripDetails";
import { ISchedule } from "../../../common/types";
import eventNames from "../../../store/signalr/eventNames";
import { addTaskForEvent, removeTaskForEvent } from "../../../store/signalr/tasksForEvents";
import AddHocModalRequest from "../AdHoc/AddHocModalRequest";
import SaveChangesPanel from "../helpers/SaveChangesPanel";
import { showTripDetailsModal } from "../../../store/modules/plannerSliceModals";
import PaneSplitter, { BLOCK_MIN_HEIGHT } from "./PaneSplitter";
import withScrolling from "react-dnd-scrolling";
import { applyGlobalChanges, IPlannerState, resetLocalState } from "../../../store/modules/plannerSlice";
import { combineIScheduleAndVisualTrips, prepareTripPlannerBatchRequest } from "../planner/virtualTripHelpers";
import ScheduledForTransport from "./TransfersTables/ScheduledForTransport";
import { getBearingAngle, getData, hubMessageHandler, setData } from "../helpers/transferScheduleHelpers";
import { IVirtualTrip } from "../../../common/plannerTypes";
import { mergeLocalAndGlobalStates } from "../../../store/modules/plannerSliceHelper";
import ErrorMessage from "../../shared/messages/ErrorMessage";
import { getPlannerLoading } from "./plannerHelpers";
import ErrorModal from "./ErrorModal";
import { applyLocalChangesForTimelineMoveToRequested } from "../../../store/modules/plannerSlice";
import Requested from "./TransfersTables/Requested";
import DraggingTransfer from "../planner/DraggingTransfer";
import { useDrop } from "react-dnd";
import { areIntervalsOverlapping } from "date-fns";

interface PlannerWidgetProps {
  selectedDay: string;
  selectedLocations: string[];

  setCurrentBookingId: any;
  setCurrentTransferId: any;
  setCurrentTransferData: any;
  setShowVehicleModal: any;
  setShowScheduleModal: any;
  setShowScheduleModalAssignVehicleOption: any;
  roles: any;
  setParentLoading: any;
  setCurrentTripPlannerId: any;
}

export interface AdHocRequestModalData {
  transferId: string;
  priority: number;
  pickupBeforeTime: any;
  pickupAfterTime: any;
  dropoffBeforeTime: any;
  dropoffAfterTime: any;
  multiload: boolean;
}

const ScrollingComponent = withScrolling("div");

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
    padding: "16px 0px 16px 0px",
  },
  loading: {
    width: "100%",
    position: "fixed",
    top: "113px",

    "& > * + *": {
      marginTop: theme.spacing(2, 0, 0, 50),
    },
  },
  dropzoneContainer: {},
  dropzoneContainerBorder: {
    border: "3px solid #F4B827",
    height: "calc(100% - 6px)",
  },
}));

const CreateLoadingLine = (props: any): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.loading} style={props.show ? { display: "" } : { visibility: "hidden" }}>
      <LinearProgress color="primary" />
    </div>
  );
};

const alertOne = require("../../../assets/sounds/alertOne.mp3");
const alertTwo = require("../../../assets/sounds/alertTwo.mp3");

const componentTaskId = "transferSchedule";

function PlannerWidget(props: PlannerWidgetProps) {
  const {
    selectedDay,
    selectedLocations,
    setCurrentBookingId,
    setCurrentTransferId,
    setCurrentTransferData,
    setShowVehicleModal,
    setShowScheduleModal,
    setShowScheduleModalAssignVehicleOption,
    roles,
    setParentLoading,
    setCurrentTripPlannerId
  } = props;
  const selectedLocation = selectedLocations.length === 1 ? selectedLocations[0] : "00000000-0000-0000-0000-000000000000";

  const classes = useStyles();
  const [checks, setChecks] = React.useState<any[]>([false]);
  const [transferMode, setTransferMode] = React.useState(getData("transferMode") || 0);
  const [errorMessage, setErrorMessage] = React.useState("");
  const { authStore } = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState(false);
  const [isRequestedItemDragging, setIsRequestedItemDragging] = React.useState(false);
  const [draggingItemName, setDraggingItemName] = React.useState("");

  const [scheduleRequestedList, setScheduleRequestedList] = React.useState<ISchedule[]>([]);
  const [transfersLength, setTransfersLength] = React.useState<number>(0);
  const [scheduleAdHocList, setScheduleAdHocList] = React.useState<ISchedule[]>([]);
  const [showAdHocModal, setShowAdHocModal] = React.useState(false);
  const [syncAdHocList, setSyncAdHocList] = React.useState(false);
  const [errorModalMessage, setErrorModalMessage] = React.useState<string | null>(null);
  const [showSaveChangesPanel, setShowSaveChangesPanel] = React.useState(false);
  const [adHocModalData, setadHocModalData] = React.useState<AdHocRequestModalData | null>(null);
  const [updatedTransfers, setUpdatedTransfers] = React.useState<any[]>([]);
  const updatedTrasfersRef = React.useRef(updatedTransfers);
  const [Updatedheight, setUpdatedheight] = React.useState(0);
  const [message, setMessage] = React.useState("");

  const plannerStore = useSelector((state: RootState) => state.plannerStore);

  const audioRequest = new Audio(alertOne);
  const audioSchedule = new Audio(alertTwo);

  const transferRequestAlert = () => {
    audioRequest.play();
  };
  const transferScheduleAlert = () => {
    audioSchedule.play();
  };

  const whenNewTransferDo = (newTransferDetails: any) => {
    if (
      (!newTransferDetails.NewLocationId || selectedLocation === newTransferDetails.NewLocationId) &&
      (!newTransferDetails.NewDate || newTransferDetails.NewDate === selectedDay)
    ) {
      hubMessageHandler(
        true,
        selectedLocations,
        selectedDay,
        newTransferDetails.TransferId,
        updatedTrasfersRef,
        setUpdatedTransfers,
        authStore.data?.CustomerId||null,
        deBounceGettScheduleList
      );
      transferRequestAlert();
    }
  };

  const whenTransferUpdatedDo = (newTransferDetails: any) => {
    if (
      (!newTransferDetails.PreviousLocationId ||
        selectedLocation === newTransferDetails.PreviousLocationId ||
        !newTransferDetails.NewLocationId ||
        selectedLocation === newTransferDetails.NewLocationId) &&
      (!newTransferDetails.PreviousDate ||
        newTransferDetails.PreviousDate === selectedDay ||
        !newTransferDetails.NewDate ||
        newTransferDetails.NewDate === selectedDay)
    ) {
      hubMessageHandler(false, selectedLocations, selectedDay, message, updatedTrasfersRef, setUpdatedTransfers,authStore.data?.CustomerId||null, deBounceGettScheduleList);
    }
  };

  const whenTransferScheduleUpdatedDo = (newTransferDetails: any) => {
    if (
      (!newTransferDetails.PreviousLocationId ||
        selectedLocation === newTransferDetails.PreviousLocationId ||
        !newTransferDetails.NewLocationId ||
        selectedLocation === newTransferDetails.NewLocationId) &&
      (!newTransferDetails.PreviousDate ||
        newTransferDetails.PreviousDate === selectedDay ||
        !newTransferDetails.NewDate ||
        newTransferDetails.NewDate === selectedDay)
    ) {
      hubMessageHandler(true, selectedLocations, selectedDay, message, updatedTrasfersRef, setUpdatedTransfers,authStore.data?.CustomerId||null, deBounceGettScheduleList);
      //transferScheduleAlert();
    }
  };

  React.useEffect(() => {
    addTaskForEvent(eventNames.newTransfer, componentTaskId, whenNewTransferDo);
    addTaskForEvent(eventNames.transferUpdated, componentTaskId, whenTransferUpdatedDo);
    addTaskForEvent(eventNames.transferScheduleUpdated, componentTaskId, whenTransferScheduleUpdatedDo);

    return () => {
      removeTaskForEvent(eventNames.newTransfer, componentTaskId);
      removeTaskForEvent(eventNames.transferUpdated, componentTaskId);
      removeTaskForEvent(eventNames.transferScheduleUpdated, componentTaskId);
    };
  }, [whenNewTransferDo, whenTransferUpdatedDo, whenTransferScheduleUpdatedDo, selectedLocation, selectedDay]);

  React.useEffect(() => {
    const trasfersOnPlanners = plannerStore.visualState.flatMap((v) => v.transfers).map((q) => q.transferId);
    const requestedList = mergeLocalAndGlobalStates(plannerStore.localState, plannerStore.globalState)
      .filter((m: IVirtualTrip) => m.statusVT === 1 && m.tripPlannerId === null && !trasfersOnPlanners.find((t) => m.virtualTripId === t))
      .map((r: IVirtualTrip) => r.transfers[0].scheduleObj);
    let _scheduleRequestedList = _.sortBy(
      requestedList,
      "createdOn"
    );
    setScheduleRequestedList(_scheduleRequestedList);
    checkIfOverlapInPlannerStore(plannerStore);

    const scheduleAdHocListFiltered = scheduleAdHocList.filter((adHocTransfer) => {
      return !trasfersOnPlanners.find((tId) => adHocTransfer.transferId === tId);
    });
    setScheduleAdHocList(_.sortBy(scheduleAdHocListFiltered, "scheduledDate"));

    setShowSaveChangesPanel(plannerStore.localState.length > 0);

    setTimeout(() => {
      const newH = topBlockRef.current?.scrollHeight;
      const winH = window ? window.innerHeight / 3 : BLOCK_MIN_HEIGHT
      let h = newH < winH ? newH : winH
      h = h > BLOCK_MIN_HEIGHT ? h : BLOCK_MIN_HEIGHT
      setTopBlockHeight(h);
    }, 10);
  }, [plannerStore]);

  const getScheduleList = async (showAll: boolean, filter: any, runBeforeDispatch?: any): Promise<void> => {
    setLoading(true);
    setParentLoading(true);
    filter.isPlannerRequest = true;
    const _res = await api.getScheduleList("", filter);
      let s = JSON.stringify(_res.data);
    if (_res !== null && _res.data !== null && _res.data.model !== null && !_res.data.hasError) {
      let _scheduleList: ISchedule[] = _res.data.model.transferResponseList;
      if (_scheduleList !== null) {
        let _scheduleRequestedList = _.sortBy(
          _scheduleList.filter((sch) => sch.status === 1 && (sch.patientOfLocation || authStore.data?.location) === selectedLocation),
          "createdOn"
        );
          let _scheduleScheduledForTransportList = null;
          if (authStore.data?.location != "" && authStore.data?.location != null) {
              _scheduleScheduledForTransportList = _.sortBy(
                  _scheduleList.filter(
                      (sch) =>
                          ((sch.status === 2 || sch.isPlannerScheduled) && (authStore.data?.location) === selectedLocation) ||
                          !authStore.data?.location
                  ),
                  "scheduledDate"
              );
          }
          else {  
              _scheduleScheduledForTransportList = _.sortBy(
                  _scheduleList.filter(
                      (sch) =>
                          ((sch.status === 2 || sch.isPlannerScheduled) && (sch.patientOfLocation || authStore.data?.location) === selectedLocation) ||
                          !authStore.data?.location
                  ),
                  "scheduledDate"
              );
          }
        let _scheduleAdHocList = _scheduleList.filter((sch) => sch.status === 13 || sch.isAdhocRequested);

        setChecks(getData("checks") || new Array(_scheduleScheduledForTransportList.length).fill(false));

        setTransfersLength(_scheduleScheduledForTransportList.length);

        setScheduleAdHocList(_.sortBy(_scheduleAdHocList, "scheduledDate"));

        const prepared_scheduleRequestedList = _scheduleRequestedList.map((item) => ({
          ...item,
          bearingAngle: getBearingAngle(
            item.originLatitude || item.originCustLocationLatitude,
            item.originLongitude || item.originCustLocationLongitude,
            item.destinationLatitude || item.destCustLocationLatitude,
            item.destinationLongitude || item.destCustLocationLongitude
          ),
        }));

          const preparedScheduleScheduledForTransportList = _scheduleScheduledForTransportList.filter(x => x.isAdhocRequested !== true).map((item) => ({
          ...item,
          bearingAngle: getBearingAngle(
            item.originLatitude || item.originCustLocationLatitude,
            item.originLongitude || item.originCustLocationLongitude,
            item.destinationLatitude || item.destCustLocationLatitude,
            item.destinationLongitude || item.destCustLocationLongitude
          ),
        }));
        const preparedTrips = combineIScheduleAndVisualTrips(
          prepared_scheduleRequestedList,
          preparedScheduleScheduledForTransportList,
          _res.data.model.virtualTrips
        );
        if (runBeforeDispatch) {
          runBeforeDispatch();
        }
        dispatch(applyGlobalChanges(preparedTrips));
      }
    }
    else{
      setScheduleRequestedList([]);
      setScheduleAdHocList([]);
    }
    setLoading(false);
    setParentLoading(false);
  };

  const deBounceGettScheduleList = React.useMemo(
    () =>
      debounce(async (showAll: boolean, filter): Promise<void> => {
        await getScheduleList(showAll, filter);
      }, 2000),
    [selectedLocation, selectedDay]
  );

  React.useEffect(() => {
    getScheduleList(false, {
      locations: selectedLocations,
      scheduledDate: selectedDay,
      Customerid:authStore.data?.CustomerId||null,
    });
    setUpdatedheight(0);
  }, [selectedLocations, selectedDay]);

  React.useEffect(() => {
    if (syncAdHocList) {
      getScheduleList(false, {
        locations: selectedLocations,
        scheduledDate: selectedDay,
        Customerid:authStore.data?.CustomerId||null,
      });
      setSyncAdHocList(false);
    }
  }, [syncAdHocList]);

  const updateChecks = React.useCallback(
    (index: number) => {
      const updatedChecks = checks.map((item, i) => (i == index ? !item : item));
      setChecks(updatedChecks);
      setData("checks", updatedChecks);
    },
    [setChecks, checks]
  );

  // do we need here at all?
  const assignToMeClick = React.useCallback(
    async (bookId: string, transId: string): Promise<void> => {
      
      if (!roles.isSMADriver) return;
      // planner is not for drivers => full implementation in TransferScheduleWidget
    },
    [roles]
  );

  const saveLocalStateToBackEnd = React.useCallback(async (): Promise<void> => {
    try {
      if (loading) {
        return;
      }
      if (localStorage.getItem("IsOverlapTransferPresent")=="true"){
        setErrorMessage("The time you have selected for this trip overlaps another trip. Please choose a new time for this trip.");
        return;
      }
      else
      setErrorMessage("");
      const modelForSaving = prepareTripPlannerBatchRequest(selectedLocation, selectedDay);
      setLoading(true);
      setParentLoading(true);
      setErrorMessage("");
      const res = await api.batchSaveScheduler("", modelForSaving);
      if (res.hasError) throw res.message;
      await getScheduleList(false, { locations: selectedLocations, scheduledDate: selectedDay,Customerid:authStore.data?.CustomerId||null, }, () => dispatch(resetLocalState()));
      setLoading(false);
      setParentLoading(false);
      transferScheduleAlert();
    } catch (error) {
      setLoading(false);
      setParentLoading(false);
      console.error(error);
      if (!_.isEmpty(error)) {
        setErrorMessage(error as string);
      } else {
        setErrorMessage("Error during saving");
      }
    }
  }, [selectedLocation, selectedDay, loading]);

  const showAdHocRequestModal = (item: AdHocRequestModalData) => {
    if (!item.multiload) {
      setadHocModalData(item);
      setShowAdHocModal(true);
    } else {
      setErrorModalMessage("Multi-load trip not supported. Please remove additional transfers from this trip before making ad-hoc requests");
    }
  };

  const topBlockRef = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const [topBlockHeight, setTopBlockHeight] = React.useState(0);

  const removeTripFromPlanner = React.useCallback(
    async ({ virtualTripId, tripPlannerId }: { virtualTripId: string; tripPlannerId: string }) => {
          try {

        if (getPlannerLoading()) {
          throw "Previous timeline update not finished";
        }
        setErrorMessage("");
        // apply local state changes
        dispatch(
          applyLocalChangesForTimelineMoveToRequested({
            tripPlannerId: tripPlannerId,
            virtualTripId: virtualTripId,
            type : Targets.REQUESTED,
          })
        );
      } catch (error) {
        setErrorMessage(error as string); // "Error while applying timeline changes"
        dispatch(setLoading(false));
        setParentLoading(false);
      }
    },
    [plannerStore]
  );

  const checkIfOverlapInPlannerStore = (plannerStore:IPlannerState): boolean | null => {
    const planners = [...new Set(plannerStore.visualState.map(item => item.tripPlannerId))];
    for (const planner of planners) {
      const trips = plannerStore.visualState.filter((q) => q.tripPlannerId === planner);
      //const updatedVirtualTrip = plannerStore.visualState.filter((q) => q.virtualTripId === updatedVirtualTripID);
      let isOverlapping:boolean=false;
      for (const trip1 of trips) {
        for (const trip2 of trips) {
          // if (trip2.virtualTripId === updatedVirtualTrip[0].virtualTripId){}
          // else 
          if (trip1.virtualTripId === trip2.virtualTripId){}
          else{
            isOverlapping = areIntervalsOverlapping(
              { start: trip1.startTrip, end: (trip1.isTripMinOverrided ? trip1.overridedendTrip : trip1.endTrip) },
              { start: trip2.startTrip, end: (trip2.isTripMinOverrided ? trip2.overridedendTrip : trip2.endTrip) }
            );
          }
          if (isOverlapping){
          localStorage.setItem("IsOverlapTransferPresent","true");
            return isOverlapping;
          }
        }
      }
    }
    localStorage.setItem("IsOverlapTransferPresent","false");
    return false;
  };

  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: "TransferRequest",
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
    drop: (item, monitor) => {
      const dropResult: IDropResult = {
        target: Targets.REQUESTED,
        removeTripFromPlanner,
      };
      return dropResult;
    },
  }));
  return (
    <div style={{ flexGrow: 1, backgroundColor: "#00152E" }}>
      {isRequestedItemDragging && (
        /* Should be on top of div topBlockRef due to Safari issue with react-dnd preview in blocks with fixed positioning  */
        <DraggingTransfer name={draggingItemName} adjustForTransferRequest={true} Draglocation ={null} selectedLocationId={selectedLocation} />
      )}

      <ScrollingComponent>
        <Paper style={{ height: "100%", paddingBottom: 100, borderRadius: 0, boxShadow: "none" }}>
          <div
            ref={topBlockRef}
            style={{
              height: topBlockHeight > 0 ? (Updatedheight > topBlockHeight ? Updatedheight :topBlockHeight) : "unset",
              overflow: "auto",
              position: "fixed",
              width: "100%",
              top: "113px",
              backgroundColor: "#00152E",
              zIndex: 1296,
            }}
          >
            <div
              ref={drop}
              className={clsx(classes.dropzoneContainer, {
                [classes.dropzoneContainerBorder]: canDrop,
              })}
            >
              <div style={{ marginBottom: 20 }}>
                <CreateLoadingLine show={loading} />
              </div>
              <Requested
                transfersList={scheduleRequestedList || []}
                rolesAndFeatures={roles}
                showAdHocRequestModal={showAdHocRequestModal}
                updatedTransfers={updatedTransfers}
                setIsRequestedItemDragging={setIsRequestedItemDragging}
                setDraggingItemName={setDraggingItemName}
                selectedLocationId={selectedLocations[0]}
              />
            </div>
          </div>

          <PaneSplitter
            updateHeight={(newHeight: number) => {
              setTopBlockHeight(newHeight);
            }}
            setUpdatedheight = {setUpdatedheight}
            currHeight={(Updatedheight > topBlockHeight ? Updatedheight :topBlockHeight) || 0}          
          />

          <div style={{ marginTop: (Updatedheight > topBlockHeight ? Updatedheight :topBlockHeight) + 75 || 0 }}>
            {errorMessage && <ErrorMessage errorMessage={errorMessage} />}

            <ScheduledForTransport
              plannerStore={plannerStore}
              rolesAndFeatures={roles}
              transferMode={transferMode}
              setTransferMode={(tMode: number) => {
                setTransferMode(tMode);
                setData("transferMode", tMode);
              }}
              updatedTransfers={updatedTransfers}
              checks={checks}
              updateChecks={updateChecks}
              setCurrentTransferId={setCurrentTransferId}
              setCurrentBookingId={setCurrentBookingId}
              setShowVehicleModal={setShowVehicleModal}
              assignToMeClick={assignToMeClick}
              selectedLocationId={selectedLocations[0]}
              selectedDay={selectedDay}
              transfersLength={transfersLength}
              setErrorMessage={setErrorMessage}
              showAdHocRequestModal={showAdHocRequestModal}
              setCurrentTripPlannerId={setCurrentTripPlannerId}         
            />


                      {
//                          roles.canRequestAdHocTransfer && (
              <AdHocRequests
                requestList={scheduleAdHocList}
                roles={roles}
                transferMode={transferMode}
                updatedTransfers={updatedTransfers}
                setCurrentTransferId={setCurrentTransferId}
                setCurrentBookingId={setCurrentBookingId}
                setShowVehicleModal={setShowVehicleModal}
                setCurrentTransferData={setCurrentTransferData}
                setShowScheduleModal={setShowScheduleModal}
                setShowScheduleModalAssignVehicleOption={setShowScheduleModalAssignVehicleOption}
              />
            //)
        }
          </div>
        </Paper>
      </ScrollingComponent>
      {showAdHocModal && (
        <AddHocModalRequest
          onClose={() => {
            setShowAdHocModal(false);
            setadHocModalData(null);
            setSyncAdHocList(true);
          }}
          modalData={adHocModalData}
        />
      )}
      {errorModalMessage && (
        <ErrorModal
          onClose={() => {
            setErrorModalMessage(null);
          }}
          errorText={errorModalMessage}
        />
      )}
      {showSaveChangesPanel && (
        <SaveChangesPanel
          onSave={saveLocalStateToBackEnd}
          onReset={() => {
            localStorage.setItem('isReArranged', "false");
            setErrorMessage("");
            dispatch(resetLocalState());
            dispatch(
              showTripDetailsModal({
                showTripDetails: false,
                tripDetails: null,
                tripDetailsModalType: MODAL_TYPE.TRIP_DETAILS,
                blockLabel: null,
              })
            );
            getScheduleList(false, {
              locations: selectedLocations,
              scheduledDate: selectedDay,
              Customerid:authStore.data?.CustomerId||null,
            });
          }}
        />
      )}
    </div>
  );
}

export default React.memo(PlannerWidget);
